import { AppBar, Container, CssBaseline, Grid, makeStyles, Paper, Toolbar } from '@material-ui/core';
import { getLogger } from 'loglevel';
import React, { useEffect, useState } from 'react';
import { Device } from '@twilio/voice-sdk';
import AudioDeviceTestWidget from './AudioDeviceTestWidget/AudioDeviceTestWidget';
import BrowserCompatibilityWidget from './BrowserCompatibilityWidget/BrowserCompatibilityWidget';
import { APP_NAME, LOG_LEVEL } from './constants';
import NetworkTestWidget from './NetworkTestWidget/NetworkTestWidget';
import ResultWidget from './ResultWidget/ResultWidget';
import { getJSON, getQueryParams } from './utils';
import './Core/utils/i18/i18n';
import { AppLogo } from './Core/constants/AppConstants';
import { Region } from './NetworkTestWidget/Tests/Tests.model';
import { dependencies } from '../package.json';

const log = getLogger(APP_NAME);
log.setLevel(LOG_LEVEL);

const useStyles = makeStyles({
  container: {
    marginTop: '2em',
  },
  paper: {
    padding: '1.5em',
  },
  tableHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1em',
  },
  logo: {
    maxHeight: '24px',
  },
});

function App() {
  // To Check if the new Twilio version is installed and the old version has been removed
  if ('@twilio/voice-sdk' in dependencies) {
    console.log('dependencies : twillio-voice new', dependencies['@twilio/voice-sdk']);
  }
  if ('twilio-client' in dependencies) {
    console.log('dependencies : twillio-client old', dependencies['twilio-client']);
  }
  const classes = useStyles();
  const [results, setResults] = useState();
  const [region, setRegion] = useState(Region.US);

  function getTURNCredentials() {
    return getJSON('app/turn-credentials').then((res) => res.iceServers as RTCIceServer[]);
  }

  function getVoiceToken() {
    return getJSON('app/token').then((res) => res.token as string);
  }

  useEffect(() => {
    //Once Application Loads, get region information from query params.
    const queryParams: any = getQueryParams(window.location.search);
    setRegion(queryParams.region);
  }, []);

  return (
    <div>
      <CssBaseline />
      <AppBar position="static">
        <Toolbar>
          <img className={`logo logo-fworks ${classes.logo}`} src={AppLogo.url} alt={AppLogo.alt} />
        </Toolbar>
      </AppBar>
      <Container className={classes.container}>
        <Grid container spacing={3}>
          {!Device.isSupported && (
            <Grid item xs={12}>
              <BrowserCompatibilityWidget />
            </Grid>
          )}
          {Device.isSupported && (
            <>
              <Grid item xs={12}>
                <Paper className={classes.paper} elevation={3}>
                  <AudioDeviceTestWidget />
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <NetworkTestWidget
                  region={region}
                  getVoiceToken={getVoiceToken}
                  getTURNCredentials={getTURNCredentials}
                  onComplete={(res) => setResults(res)}
                />
              </Grid>
              <Grid item xs={12}>
                <ResultWidget results={results} />
              </Grid>
            </>
          )}
        </Grid>
      </Container>
    </div>
  );
}

export default App;
